/**
 * Article content creation helpers
 */
import type { ArticleContent, DAGObject } from '../dag/types.js';
import type { Identity } from '../identity/identity.js';

export interface CreateArticleOptions {
  title: string;
  body: string;
  tags?: string[];
  replyTo?: string; // Hash of parent article (for replies)
}

/**
 * Create a new article object
 */
export function createArticle(
  identity: Identity,
  options: CreateArticleOptions
): DAGObject<ArticleContent> {
  const content: ArticleContent = {
    title: options.title,
    body: options.body,
    tags: options.tags ?? [],
  };

  const parents = options.replyTo ? [options.replyTo] : [];
  return identity.createObject('article', content, parents);
}

/**
 * Check if object is an article
 */
export function isArticle(obj: DAGObject): obj is DAGObject<ArticleContent> {
  return obj.type === 'article';
}

/**
 * Get article preview (first N characters of body)
 */
export function getArticlePreview(article: DAGObject<ArticleContent>, maxLength = 200): string {
  const body = article.content.body;
  if (body.length <= maxLength) return body;
  return body.slice(0, maxLength).trim() + '...';
}
